import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Target, Brain, ShieldCheck, Rocket, Heart } from 'lucide-react';
export function ResultsSection() {
  const benefits = [{
    text: 'Mayor claridad sobre lo que quieres construir',
    icon: <Sparkles className="w-6 h-6 text-pink-400" data-id="element-151" />
  }, {
    text: 'Hábitos que te acercan a tus metas',
    icon: <Target className="w-6 h-6 text-purple-400" data-id="element-152" />
  }, {
    text: 'Mentalidad más fuerte y enfocada',
    icon: <Brain className="w-6 h-6 text-blue-400" data-id="element-153" />
  }, {
    text: 'Confianza para usar herramientas nuevas',
    icon: <ShieldCheck className="w-6 h-6 text-pink-400" data-id="element-154" />
  }, {
    text: 'Capacidad de crear oportunidades digitales',
    icon: <Rocket className="w-6 h-6 text-purple-400" data-id="element-155" />
  }, {
    text: 'Sensación de crecimiento personal real',
    icon: <Heart className="w-6 h-6 text-pink-400" data-id="element-156" />
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-slate-950 via-pink-950/20 to-slate-950" data-id="element-157">
      <div className="max-w-7xl mx-auto" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-159">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6 max-w-3xl mx-auto" data-id="element-160">
            Cuando trabajas tu mente y tus hábitos, los resultados empiezan a
            cambiar.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-161">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="order-2 lg:order-1 relative" data-id="element-162">
            <div className="absolute inset-0 bg-pink-500/20 blur-3xl rounded-full opacity-50 -z-10" data-id="element-163"></div>
            <img src="https://cdn.magicpatterns.com/uploads/k1vtbtWvDunw83cixsTZhb/task_01kkt9mc7sewyt7y0p0wkbb8r8_1773630296_img_0.webp" alt="Resultados del kit" className="w-full h-auto rounded-3xl shadow-2xl border border-white/10" data-id="element-164" />
          </motion.div>

          <div className="order-1 lg:order-2 grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-165">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white/[0.06] backdrop-blur-sm p-6 rounded-2xl shadow-md border border-pink-500/10 flex flex-col gap-4 hover:shadow-lg hover:border-pink-500/30 transition-all" data-id="element-166">
                <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center" data-id="element-167">
                  {benefit.icon}
                </div>
                <p className="text-slate-200 font-medium leading-snug" data-id="element-168">
                  {benefit.text}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}